module.exports = __webpack_public_path__ + "static/media/fail.ed4bd301.mp3";